import React, {useMemo} from 'react';
import styled from 'styled-components';
import {useSelector} from 'react-redux';
import {selectActiveCircle} from './dashboardSlice';
import UserPin from './UserPin';
import {
    circlesByID,
    currentCircleDevices,
    currentCircleUsers,
    deviceByID,
    pendingByID,
    usersByID
} from '../../app/models/ormSelectors';
import {tabletWidth} from '../../mixins';
import {
    selectPseudoFlow,
    selectPseudoPhone,
    selectTrackingStatus,
} from '../onboarding/onboardingSlice';
import FakeUserPin from './FakeUserPin';
import {selectUserInfo} from '../login/loginSlice';
import InviteButton from '../invite/InviteButton';

const StyledMembersList = styled.div`
  position: absolute;
  z-index: 300;
  top: 16px;
  left: 110px;
  width: auto;
  max-width: 300px;
  display: grid;
  grid-gap: 16px;
  grid-template-columns: repeat(auto-fill, minmax(48px, 1fr));
  grid-template-rows: repeat(auto, 50px);
  align-items: center;
  justify-content: space-between;
  
  @media screen and (min-width: ${tabletWidth}) {
    max-width: 500px;
  }
  
  @media screen and (max-width: ${tabletWidth}) and (orientation: portrait) {
    top: unset;
    bottom: 68px;
    left: 80px;
}
`


const CircleMembers = () => {
    const activeCircle = useSelector(selectActiveCircle);
    const usersById = useSelector(usersByID);
    const invitedUsersById = useSelector(pendingByID);
    const isPseudoFlow = useSelector(selectPseudoFlow);
    const pseudoTrackingDone = useSelector(selectTrackingStatus);
    const ownerInfo = useSelector(selectUserInfo);
    const phoneNumber = useSelector(selectPseudoPhone);
    const currCircleMembers = useSelector(currentCircleUsers);
    const currCircleDevices = useSelector(currentCircleDevices);

    const userToDisplay = usersById(currCircleMembers);
    const devicesToDisplay = usersById(currCircleDevices);
    const pendingUsers = invitedUsersById();

    const pendingInCurrCircle = useMemo(() => pendingUsers.filter(user => user.circleID === activeCircle).map(user => user.id), [activeCircle, pendingUsers]);

    const pendingToDisplay = usersById(pendingInCurrCircle);

    const fakeUsersToDisplay = [
        {
            id: ownerInfo.id,
            appStatus: null,
            name: ownerInfo.name
        },
        {
            id: 'pseudo_fake_user',
            fakeAvatar: '../images/blurred-avatar-square.png',
            appStatus: 'PENDING',
            name: phoneNumber,
            isFakeUser: true,
        }
    ];

    const renderUser = (user, index) => user && <UserPin user={user} key={index} showBatteryLevel={true}/>
    const renderPendingUser = (user) => user && <UserPin user={user} key={user.id} pending={true}/>
    const renderFakeUser = (user, index) => user && <FakeUserPin user={user} key={index}/>

    if (isPseudoFlow && pseudoTrackingDone) {
        return (
            <>
                <StyledMembersList>
                    {fakeUsersToDisplay.map(renderFakeUser)}
                </StyledMembersList>
            </>
        )
    }

    return (
        <>
            <StyledMembersList>
                {userToDisplay.map(renderUser)}
                {devicesToDisplay.map(renderUser)}
                {pendingToDisplay.map(renderPendingUser)}
                <InviteButton/>
            </StyledMembersList>
        </>

    )
};

export default CircleMembers;